import React from 'react'
import { Typography, Button } from '@material-ui/core';

function Premium(props) {
    const {className, ...rest}= props;
    return (
        <div
        {...rest}
        >
            <Typography variant="h4" align="center">
                &copy;DAMODAR
            </Typography>
           
            <Button variant="contained" color="primary" fullWidth>
                Damodar. Theme
            </Button>
           
        </div>
    )
}

export default Premium
